import { Loader, Stack, Text } from "@mantine/core";
import { SystemEmailPreview } from "../../../services/admin/systemEmails.service";
import { HeldEmailLoadError } from "./HeldEmailLoadError";
import { SystemEmailPreviewFrame } from "./SystemEmailPreviewFrame";

interface Props {
  preview?: SystemEmailPreview;
  error?: Error | null;
  loading: boolean;
}

export function SystemEmailPreviewContent({ preview, error, loading }: Props) {
  if (loading) return <Loader aria-label="Loading email preview" />;
  if (error)
    return <HeldEmailLoadError error={error} title="Preview unavailable" />;
  return preview ? (
    <Stack gap="sm">
      <Text fw={600}>{preview.subject}</Text>
      <SystemEmailPreviewFrame
        html={preview.html}
        title={`Preview of ${preview.subject}`}
      />
    </Stack>
  ) : null;
}
